(function () {
  function initReveals() {
    var els = document.querySelectorAll('.zt-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('zt-visible'); });
      return;
    }
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('zt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.dataset.ztDelay || '0', 10);
        setTimeout(function () { el.classList.add('zt-visible'); }, delay);
        obs.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px' });
    els.forEach(function (el) { obs.observe(el); });

    // Respaldo: si por lo que sea el observador no dispara, nada queda invisible
    setTimeout(function () {
      document.querySelectorAll('.zt-reveal:not(.zt-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.2) el.classList.add('zt-visible');
      });
    }, 1600);
  }

  function initFaq() {
    var items = document.querySelectorAll('.zt-faq__item');
    if (!items.length) return;
    items.forEach(function (item) {
      var btn = item.querySelector('.zt-faq__pregunta');
      var resp = item.querySelector('.zt-faq__respuesta');
      if (!btn || !resp) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('zt-abierto');
        items.forEach(function (otro) {
          otro.classList.remove('zt-abierto');
          var r = otro.querySelector('.zt-faq__respuesta');
          if (r) r.style.maxHeight = null;
          var b = otro.querySelector('.zt-faq__pregunta');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
        if (!abierto) {
          item.classList.add('zt-abierto');
          resp.style.maxHeight = resp.scrollHeight + 'px';
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  function start() {
    initReveals();
    initFaq();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
